export default __webpack_public_path__ + "static/media/customer_uncontracted.4234ed94.svg";